import React, { Suspense } from 'react';

const LiveMapInner = React.lazy(() => import('./LiveMapInner'));

export default function LiveMap() {
  return (
    <Suspense fallback={
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', color:'#64748b', fontSize:14 }}>
        Loading map...
      </div>
    }>
      <LiveMapInner />
    </Suspense>
  );
}
